import React from 'react'
import { Route, IndexRoute } from 'react-router'
import Splitter from '../helpers/Splitter'

const CertificatesContainer = Splitter(() =>
  import('../components/common/Certificates/CertificatesContainer')
)
const UserCertificates = Splitter(() =>
  import('../components/common/Certificates/UserCertificates')
)
const ViewCertificate = Splitter(() =>
  import('../components/common/Certificates/ViewCertificate')
)

export const certificatesRoutes = (
  <Route path="certificates" component={CertificatesContainer}>
    <IndexRoute component={UserCertificates} />
    <Route path="view/:certificateId" component={ViewCertificate} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/certificatesRoutes.js